export default {
  'memberAreaCouponHistory.title': '票券記錄',
  'memberAreaCouponHistory.time': '時間',
  'memberAreaCouponHistory.serial_number': '序號',
  'memberAreaCouponHistory.redeem_store': '核銷店家',
  'memberAreaCouponHistory.redeem_no': '核銷編號',
} as Record<string, string>;
